export enum FeatureToggleKey {
  ACCOUNT_ID,
  ACCOUNT_NAME,
}

export interface FeatureToggle {
  key: FeatureToggleKey;
  name: string;
}
